import { _DEBUG, _urlParams } from './constants';

export const addToBasketFunctions = () => {
  $('.btn-add-to-cart:not(.initialized)')
    .click((event) => {
      event.preventDefault();
      $('#modal-productAdded').modal('hide'); // Remove a poosibly existing Add2Cart Modal

      const helperElement = $(event.currentTarget).parent().children('input[name="abskt"]');
      const id = helperElement.val();
      let amount = parseInt($('#amnt_' + id).val());

      if (amount > 0) {
        // on pdp we will use the input amount
      } else {
        amount = 1;
      }

      $('._add2cart-reco_id_' + id).remove(); // Remove add2Cart-Reco in case of adding the same product
      const helperUpsellingAction = $(event.currentTarget).parent().parent().parent().attr('data-dl-action');
      const helperUpsellingList = $(event.currentTarget)
        .parent()
        .parent()
        .parent()
        .attr('data-dl-addtocartupsellinglist');

      // console.log('##############################');
      // console.log(helperElement);
      // console.log('##############################');

      if (helperUpsellingAction) {
        // WEB-2737 special case to close the default modal and reopen for success modal
        // When this process runs very fast the new modal will not been show
        showLoadingScreen();
        let timeout;
        let delay = 1000;
        timeout = window.setTimeout(() => {
          console.log('[paused] Adding item with internal ID ' + id + ' and amount ' + amount + ' to basket.');
          apnCart.add(id, amount);
        }, delay);
      } else {
        console.log('Adding item with internal ID ' + id + ' and amount ' + amount + ' to basket.');
        apnCart.add(id, amount);
      }

      // Push add to basket event to GTM data layer WEB-2012
      if (window['google_tag_manager']) {
        if (_DEBUG) console.log('--------------Check Mengen -------------------------------');
        // Fix WEB-3751 ggf Mengenüberschreitung
        var amount_incart = 0;
        let maxsales = helperElement.data('amount-allowed');

        if (_DEBUG) {
          console.log('ID: ' + id);
          console.log('Currently in cart:');
          console.log(live_basket);
        }

        for (let cartitem of live_basket) {
          if (cartitem['PKpro_id'] == id) {
            if (_DEBUG) console.log('ID:' + id + ' is allready in cart');
            amount_incart = cartitem['bas_amount'];
          }
        }

        if (_DEBUG) {
          console.log('amount_incart: ' + amount_incart);
          console.log('submitted amount: ' + amount);
          console.log('maxsales: ' + maxsales);
        }

        if (parseInt(amount_incart) + parseInt(amount) > parseInt(maxsales)) {
          if (_DEBUG) console.log('Mengenüberschreitung!!!');
          //amount = maxsales;
          amount = parseInt(maxsales) - parseInt(amount_incart);
          if (_DEBUG) console.log('force amount to:' + amount);
        } else {
          if (_DEBUG) console.log('amount of:' + amount + ' ok');
        }

        // --------------Eof fix Mengen ------------------------------

        window.dataLayer = window.dataLayer || [];

        let pageType = 'undefined pageType';
        if (
          typeof window['google_tag_manager']['GTM-5GNVZ2M'] === 'object' &&
          typeof window['google_tag_manager']['GTM-5GNVZ2M'].dataLayer === 'object'
        ) {
          pageType = window['google_tag_manager']['GTM-5GNVZ2M'].dataLayer.get('pageType');
        }

        let action = 'undefined (' + pageType + ')';
        let _netprice = parseFloat(
          (
            (parseFloat(helperElement.data('gross-price')) / (100 + parseFloat(helperElement.data('tax')))) *
            100
          ).toFixed(2),
        );

        let basketChange = {
          brand: helperElement.data('brand'),
          grossPrice: helperElement.data('gross-price'),
          netPrice: _netprice,
          internalId: helperElement.data('internal-id'),
          name: helperElement.data('name'),
          pzn: String(helperElement.data('pzn')),
          quantity: amount,
          manufacturer: helperElement.data('manufacturer'),
          manufacturerid: helperElement.data('manufacturerid'),
        };

        if (!pageType) {
          console.log('pageType undefined');
          basketChange.action = 'undefined pagetype Add to Basket';
        } else if (pageType === 'productdetail') {
          basketChange.action = 'PDP Item Add to Basket';
        } else if (pageType === 'category' || pageType.indexOf('category_subpage') !== -1) {
          basketChange.action = 'Category Page Item Add to Basket';
        } else if (pageType === 'search') {
          basketChange.action = 'Search Results Item Add to Basket';
        } else if (pageType === 'service_wechselwirkungscheck') {
          basketChange.action = 'Interaction Check Item Add to Basket';
        } else if (helperUpsellingAction) {
          basketChange.action = helperUpsellingAction;
          basketChange.addToCartUpsellingList = 'Add to Cart "' + helperUpsellingList + '"';
        }

        if (_DEBUG) {
          console.log('Event:addToBasket,basketChange:');
          console.log(basketChange);
        }

        // Ideally we should have passed the product list name and position here (WEB-2030),
        // but the shop cannot support this with acceptable effort. Therefore this data gets added in GTM.
        dataLayer.push({
          event: 'addToBasket',
          basketChange: basketChange,
        });
      }
    })
    .addClass('initialized');
};

export default () => {
  const $productAmountCounter = $('.js_product-amount');

  if ($productAmountCounter.length) {
    $productAmountCounter.each((i, elem) => {
      let timeout;
      const delay = 500;
      let $amount = $('._input_autosubmit', elem);
      $('.btn', elem).on('click touch', function (event) {
        if ($(event.currentTarget).hasClass('--delete')) {
          $('.cart-product-list__item__remove', $(event.currentTarget).parents('.cart-product-list__item')).trigger(
            'click',
          );
          return;
        }

        let currentAmount = parseInt($amount.val());
        if ($(event.currentTarget).hasClass('--increase')) {
          $amount.val(currentAmount + 1);
        } else if ($(event.currentTarget).hasClass('--decrease')) {
          $amount.val(Math.max(currentAmount - 1, 1));
        }

        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => {
          $amount.trigger('change');
        }, delay);
      });
    });

    // Input for amount of items
    $('._input_autosubmit').change(function () {
      if (_DEBUG) {
        console.log(
          'Changing basket item amount from ' + $(this).data('original-amount') + ' to ' + $(this).val() + '.',
        );
      }
      // Try a simple submit, no matter what tracking is
      // Firefox fix WEB-2339
      $('#basket').submit();

      if (_DEBUG) console.log('-------------- Check Mengen Basketpage-------------------------------');
      // at this page isn´t submitted additional amount!
      // its the new amount in basket!
      var amount_incart = 0;
      let maxsales = $(this).data('amount-allowed');
      let amount = $(this).val();
      let id = $(this).data('internal-id');

      if (_DEBUG) {
        console.log('ID: ' + id);
        console.log('Currently in cart:');
        console.log(live_basket);
      }

      for (let cartitem of live_basket) {
        if (cartitem['PKpro_id'] == id) {
          if (_DEBUG) console.log('ID:' + id + ' is allready in cart');
          amount_incart = cartitem['bas_amount'];
        }
      }

      if (_DEBUG) {
        console.log('amount_incart: ' + amount_incart);
        console.log('submitted new amount: ' + amount);
        console.log('maxsales: ' + maxsales);
      }

      if (parseInt(amount) > parseInt(maxsales)) {
        if (_DEBUG) console.log('Mengenüberschreitung!!!');
        amount = maxsales;
        console.log('force amount to:' + amount);
      } else {
        if (_DEBUG) console.log('new amount of:' + amount + ' ok');
      }
      // --------------Eof fix Mengen ------------------------------

      // Push event to GTM data layer
      if (window['google_tag_manager'] && $(this).data('original-amount') !== $(this).val()) {
        window.dataLayer = window.dataLayer || [];

        let _netprice = parseFloat(
          ((parseFloat($(this).data('gross-price')) / (100 + parseFloat($(this).data('tax')))) * 100).toFixed(2),
        );

        dataLayer.push({
          event: $(this).data('original-amount') > $(this).val() ? 'removeFromBasket' : 'addToBasket',
          basketChange: {
            action: 'Basket Page Item Amount Change',
            brand: $(this).data('brand'),
            grossPrice: $(this).data('gross-price'),
            netPrice: _netprice,
            internalId: $(this).data('internal-id'),
            name: $(this).data('name'),
            pzn: String($(this).data('pzn')),
            quantity: Math.abs($(this).data('original-amount') - amount),
            manufacturer: $(this).data('manufacturer'),
            manufacturerid: $(this).data('manufacturerid'),
          },
        });
      }
    });

    // Warenkorb X-Icon
    $('.cart-product-list__item__remove').on('click touch', function () {
      $($(this).data('hide')).hide(700);
      if (_DEBUG) {
        console.log('Removing basket item.', this);
      }
      $('#basket-amount_' + $(this).data('removeitem')).val(0);

      // Try a simple submit, no matter what tracking is
      // Firefox fix WEB-2339
      $('#basket').submit();

      // Push event to GTM data layer
      if (window['google_tag_manager'] && $(this).data('prev') !== $(this).val()) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'removeFromBasket',
          basketChange: {
            action: 'Basket Page Item Removal',
            brand: $(this).data('brand'),
            grossPrice: $(this).data('gross-price'),
            internalId: $(this).data('internal-id'),
            name: $(this).data('name'),
            pzn: $(this).data('pzn'),
            quantity: $(this).data('original-amount'),
          },
        });
      }
    });
    // special buttons with remove function for special products
    $('._js_item__remove').on('click touch', function () {
      $($(this).data('hide')).hide(700);
      if (_DEBUG) {
        console.log('Removing basket item.', this);
      }
      $('#basket-amount_' + $(this).data('removeitem')).val(0);

      // Try a simple submit, no matter what tracking is
      // Firefox fix WEB-2339
      $('#basket').submit();

      // Push event to GTM data layer
      if (window['google_tag_manager'] && $(this).data('prev') !== $(this).val()) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'removeFromBasket',
          basketChange: {
            action: 'Basket Page Item Removal',
            brand: $(this).data('brand'),
            grossPrice: $(this).data('gross-price'),
            internalId: $(this).data('internal-id'),
            name: $(this).data('name'),
            pzn: $(this).data('pzn'),
            quantity: $(this).data('original-amount'),
          },
        });
      }
    });
  }
};
